import { render, staticRenderFns } from "./chosen-hand.vue?vue&type=template&id=2064ee79&"
import script from "./chosen-hand.vue?vue&type=script&lang=js&"
export * from "./chosen-hand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports